<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0px;
  box-sizing: border-box;
}
body{
  margin: 0px;
  min-width:1024px;
}
.container{
  overflow: hidden;
}
.clearfix::after
{
    content:"";
    clear:both;
    display:table;
}
pre{
  background-color: #2B2B2B !important;
  color: #fff !important;
}
</style>
